var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoAnalyzeA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C5.58172 2 2 5.58172 2 10V19.9C2 20.2314 1.73137 20.5 1.4 20.5H0.6C0.268629 20.5 0 20.2314 0 19.9V10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10V22.4C20 23.2837 19.2837 24 18.4 24H16.1C15.2163 24 14.5 23.2837 14.5 22.4V16.5H8.6C7.71634 16.5 7 15.7837 7 14.9V12.6C7 11.7163 7.71634 11 8.6 11H14.5V10C14.5 7.51472 12.4853 5.5 10 5.5C7.51472 5.5 5.5 7.51472 5.5 10V22.4C5.5 23.2837 4.78366 24 3.9 24H0.6C0.268629 24 0 23.7314 0 23.4V22.6C0 22.2686 0.268629 22 0.6 22H3.5V10C3.5 6.41015 6.41015 3.5 10 3.5C13.5899 3.5 16.5 6.41015 16.5 10V11.7761C16.5 12.4521 15.952 13 15.2761 13H9V14.5H15.1C15.8732 14.5 16.5 15.1268 16.5 15.9V22H18V10C18 5.58172 14.4183 2 10 2Z",
    fill: "#003393"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnalyzeA);
export default __webpack_public_path__ + "static/media/logo-Analyze-A.f85896afe3c49a90ed608e219b68c4eb.svg";
export { ForwardRef as ReactComponent };